import { render, staticRenderFns } from "./CompanyCreate.vue?vue&type=template&id=086ffe64"
import script from "./CompanyCreate.vue?vue&type=script&lang=ts"
export * from "./CompanyCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports